<template>
  <MaterialCard
    v-if="selected.id"
    :style="`position: sticky; top: ${offsetTop}px; z-index: 10;`"
    color="green"
    full-width
  >
    <v-form
      v-model="ok"
    >
      <v-container py-0>
        <v-layout wrap>
          <v-flex
            xs2
            md3
          >
            <v-text-field
              class="purple-input"
              label="管理番号"
              readonly
              :value="id"
            />
          </v-flex>
          <v-spacer />
          <v-flex
            xs10
            md8
          >
            <v-select
              v-model="type"
              class="purple-input"
              label="タイプ"
              :readonly="id !== 'new'"
              :items="groupTypes"
              :rules="[rules.required]"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <GroupSelect
              v-if="parentGroupId || id === 'new'"
              v-model.number="parentGroupId"
              label="親会社"
              :group="group"
              :disable-area="true"
              :disable-item="isChildrenOfSelected"
              :rules="[rules.required]"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <v-text-field
              v-model.trim="name"
              class="purple-input"
              label="名称"
              :rules="[rules.required]"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <v-text-field
              v-if="type === 'company'"
              v-model.trim="address"
              class="purple-input"
              label="住所"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <v-text-field
              v-if="type === 'company'"
              v-model.trim="tel"
              class="purple-input"
              label="電話番号"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <v-text-field
              v-if="type === 'company' && (company.id === 1 ? selected.level === 1 : selected.level === 0)"
              v-model.trim="representativeName"
              class="purple-input"
              label="担当"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <v-text-field
              v-if="(type === 'company' && id === 'new') && parentGroupId === 1"
              v-model.trim="representativePassword"
              class="purple-input"
              label="管理者パスワード"
              hint="8文字以上で入力してください。"
              :rules="[rules.required, rules.min]"
              :append-icon="visibility.password ? 'mdi-eye' : 'mdi-eye-off'"
              :type="visibility.password ? 'text' : 'password'"
              @click:append="visibility.password = !visibility.password"
            />
          </v-flex>
          <v-flex xs12>
            <v-textarea
              v-model.trim="remarks"
              class="purple-input"
              label="備考"
            />
          </v-flex>
          <v-flex
            xs12
            style="display: flex; justify-content: flex-end;"
          >
            <v-btn
              color="success"
              :disabled="!dirty || !ok || loading"
              :loading="loading"
              @click="onRegister"
            >
              更新
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </MaterialCard>
</template>

<script>
import { mapState } from 'vuex'
import { GroupSelect } from '@/components/input'

export default {
  components: {
    GroupSelect
  },
  props: {
    selected: {
      type: Object,
      default: () => null
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      // selected company info
      id: -1,
      name: '',
      type: '',
      parentGroupId: null,
      address: '',
      tel: '',
      representativeName: '',
      remarks: '',
      /// ///
      representativePassword: '',
      ok: false,
      groupTypes: [
        { value: 'company', text: '会社' },
        { value: 'area', text: 'エリア' }
      ],
      rules: {
        required: value => !!value || '入力必須項目です。',
        min: v => v.length >= 8 || '8文字以上で入力してください。'
      },
      visibility: {
        password: false
      }
    }
  },
  computed: {
    ...mapState('display', ['offsetTop']),
    ...mapState('app', ['company']),
    ...mapState('groups', ['group']),
    typeName () {
      if (!this.type) return ''
      return this.groupTypes.find(v => v.value === this.type).text
    },
    dirty () {
      if (!this.selected) return false
      return !props.every(prop => this.selected[prop] === this[prop])
    }
  },
  watch: {
    selected (value) {
      props.forEach(prop => { this[prop] = value[prop] })
    }
  },
  methods: {
    onRegister () {
      const data = {
        id: this.id,
        type: this.type,
        name: this.name,
        parentGroupId: this.parentGroupId,
        address: this.address,
        tel: this.tel,
        remarks: this.remarks,
        representativeName: this.representativeName
      }
      if (this.parentGroupId === 1) {
        data.representativePassword = this.representativePassword
      }
      this.$emit('register', data)
    },
    /**
     * 引数で指定したグループが、画面で選択されたグループの子孫かどうかを判断します。
     */
    isChildrenOfSelected (group) {
      const queue = [this.group]

      while (queue.length > 0) {
        const g = queue.pop()

        if (g.id === this.selected.id) {
          continue
        }
        if (g.id === group.id) {
          return false
        }

        queue.push(...g.children)
      }

      return true
    }
  }
}
const props = ['id', 'name', 'type', 'parentGroupId', 'address', 'tel', 'representativeName', 'remarks', 'representativePassword']
</script>
